import { render, staticRenderFns } from "./tabSensitiveConfig.vue?vue&type=template&id=48b1e2e0&scoped=true&"
import script from "./tabSensitiveConfig.vue?vue&type=script&lang=js&"
export * from "./tabSensitiveConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1e2e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b1e2e0')) {
      api.createRecord('48b1e2e0', component.options)
    } else {
      api.reload('48b1e2e0', component.options)
    }
    module.hot.accept("./tabSensitiveConfig.vue?vue&type=template&id=48b1e2e0&scoped=true&", function () {
      api.rerender('48b1e2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/sensitiveWord/tabSensitiveConfig.vue"
export default component.exports